// Значение подставляется при сборке: bunfig.toml (dev) и define в scripts/build.ts (prod).
export const config = {
  apiBaseUrl: (process.env.BUN_PUBLIC_API_BASE_URL ?? "").replace(/\/+$/, ""),
  // Пусто — кнопки «Войти через Telegram» нет: виджет работает только на домене бота из BotFather.
  telegramBotId: (process.env.BUN_PUBLIC_TELEGRAM_BOT_ID ?? "").trim(),
} as const;
